import { render, staticRenderFns } from "./music.vue?vue&type=template&id=b01bed34&scoped=true&"
import script from "./music.vue?vue&type=script&lang=ts&"
export * from "./music.vue?vue&type=script&lang=ts&"
import style0 from "./music.vue?vue&type=style&index=0&id=b01bed34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01bed34",
  null
  
)

export default component.exports